import React, { Component } from 'react';
import axios from 'axios';
import qs from 'qs';

import { runValidationCheck, checkField, checkValidation, toggleButton, doHandleSuccess, doHandleErrors } from '../../../utils';
import { API_URL } from '../../../constants';
import FormError from '../../common/ui/FormError';
import TextInput from '../../common/ui/TextInput';
import TextArea from '../../common/ui/TextArea';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.INITIAL_STATE = {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      msg: '',
      formErrors: {
        firstname: '',
        lastname: '',
        email: '',
        msg: ''
      }
    };

    this.state = this.INITIAL_STATE;
    this.doFormHandler = this.doFormHandler.bind(this);
  }

  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => { this.validateField(name, value)});
  }

  validateField(name, value) {
    let result = checkField(name, value, this.state.formErrors);
    this.setState(result);
  }

  renderError(id) {
    if (this.state.formErrors[id] !== '') {
      return <FormError id={`e_${id}`} message={this.state.formErrors[id]} />;
    }
  }

  async doFormHandler(e) {
    e.preventDefault();
    const check = runValidationCheck(this.state, this.state.formErrors);
    this.setState({ formErrors: check });

    if (checkValidation(this.state, this.state.formErrors)) {
      const btn_details = { txt: 'Send Message', id: '#btn_submit' };
      const data = {
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        email: this.state.email,
        phone: this.state.phone,
        msg: this.state.msg
      };
      toggleButton(btn_details, false);

      try {
        const response = await axios({
          method: 'post',
          url: API_URL,
          data: qs.stringify(data)
        });

        // console.log(response);
        doHandleSuccess(btn_details, true, 'Contact Success', response.data.msg);
      }
      catch (err) {
        doHandleErrors(err, btn_details, 'Contact Error');
      }
    }
  }

  render() {
    return (
      <section id="contact-form">
        <div className="container">
        	<div className="row">
        		<div className="col-lg-8 mx-auto">
        			<h2 className="anim_piece text-center">Contact Form</h2>
              <hr />
              <p className="anim_piece text-center">Kindly email me at <a href="mailto:fernandedios@gmail.com">fernandedios@gmail.com</a>, or use the form below:</p>
        			<form id="contact_form" className="anim_piece pt-3" onSubmit={this.doFormHandler}>
        				<div className="controls">
        					<div className="row">
        						<div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="firstname">First Name *</label>
                        <TextInput id="firstname" title="First Name" value={this.state.firstname} onChange={this.handleInput} />
                        {this.renderError('firstname')}
                      </div>
        						</div>

        						<div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="lastname">Last Name *</label>
                        <TextInput id="lastname" title="Last Name" value={this.state.lastname} onChange={this.handleInput} />
                        {this.renderError('lastname')}
                      </div>
        						</div>
        					</div>

        					<div className="row">
        						<div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="email">Email Address *</label>
                        <TextInput id="email" type="email" title="Email Address" value={this.state.email} onChange={this.handleInput} />
                        {this.renderError('email')}
                      </div>
        						</div>
        						<div className="col-md-6">
                      <div className="md-form">
                        <label htmlFor="phone">Phone Number</label>
                        <TextInput id="phone" type="tel" title="Phone Number" value={this.state.phone} onChange={this.handleInput} />
                        {this.renderError('phone')}
                      </div>
        						</div>
        					</div>

        					<div className="row">
        						<div className="col-md-12">
                      <div className="md-form">
                        <label htmlFor="msg">Message *</label>
                        <TextArea id="msg" title="Message" rows="4" value={this.state.msg} onChange={this.handleInput} />
                        {this.renderError('msg')}
                      </div>
        						</div>
        						<div className="col-md-12">
        							<button id="btn_submit" type="submit" className="btn btn-dark-green btn-send">Send Message</button>
        						</div>
        					</div>

        				</div>
        			</form>
        		</div>
        	</div>
        </div>
      </section>
    );
  }
}

export default ContactForm;
